module.exports = "https://coursera_assets.s3.amazonaws.com/images/be5165931ea9406f9c9ab22bb2dc084c.svg";